import { HomeInfoPage } from './HomeInfoPage';
export default HomeInfoPage;
